import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-native-builds-integrations-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './native-builds-integrations-section.component.html',
  styleUrl: './native-builds-integrations-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsIntegrationsSectionComponent {
  protected readonly integrations = [
    {
      icon: '@tui.fa.brands.github',
      name: 'GitHub',
      description: 'Including GitHub Enterprise',
    },
    {
      icon: '@tui.fa.brands.gitlab',
      name: 'GitLab',
      description: 'Including self-hosted instances',
    },
    {
      icon: '@tui.fa.brands.bitbucket',
      name: 'Bitbucket',
      description: 'Cloud and self-hosted',
    },
    {
      icon: '@tui.fa.brands.microsoft',
      name: 'Azure DevOps',
      description: 'Full support for Azure repos',
    },
  ];
}
